import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    userId: Number,
  };

  connect() {
    if (!this.element.classList.contains('user-mention')) {
      this.element.classList.add('user-mention');
    }
  }
}
